import { MaterialReactTable } from "material-react-table";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { fetchCustomerEvents } from "../../slices/customer/events/thunk";
// import { customerIdData } from "./constants/constantFunctionsView";
import { Chargingcoloumn } from "./constants/ChargingSessionColoumn";
import { fetchStationChargingHistory } from "../../slices/customer/events/thunk";

export default function UsageHistory({ stationID, activeTab }) {
  const dispatch = useDispatch();
  //   const customerId = customerIdData();
  const eventData = useSelector(
    (state) => state?.CustomerEvent?.stationChargingHistory || []
  );

  const [loading, setLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(true);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // store cursor per page
  const [cursorMap, setCursorMap] = useState({ 0: "" });

  // 🔹 Fetch data when page changes
  useEffect(() => {
    if (activeTab !== "5") return; // Only fetch when Usage History tab is active
    const cursor = cursorMap[pagination.pageIndex] ?? "";

    setLoading(true);

    dispatch(
      fetchStationChargingHistory(stationID, cursor, setLoading, setHasNextPage)
    );
  }, [stationID, pagination.pageIndex, activeTab]);

  // 🔹 Save next page cursor
  useEffect(() => {
    if (eventData.length > 0) {
      const lastItem = eventData[eventData.length - 1];
      setCursorMap((prev) => ({
        ...prev,
        [pagination.pageIndex + 1]: lastItem?.chargingCompletedAt || "",
      }));

      setHasNextPage(eventData.length === pagination.pageSize);
    } else {
      setHasNextPage(false);
    }
  }, [eventData]);

  // 🔹 Manual control of next/previous
  const handlePaginationChange = (updater) => {
    const newPagination =
      typeof updater === "function" ? updater(pagination) : updater;

    // block if no next page
    if (newPagination.pageIndex > pagination.pageIndex && !hasNextPage) return;

    setPagination(newPagination);
  };

  const Chargingcoloumns = Chargingcoloumn();

  return (
    <div className="border rounded-1 px-0 my-3 h-100">
      <MaterialReactTable
        columns={Chargingcoloumns}
        data={eventData}
        manualPagination
        onPaginationChange={handlePaginationChange}
        rowCount={
          pagination.pageIndex * pagination.pageSize +
          eventData.length +
          (hasNextPage ? 1 : 0)
        }
        state={{ isLoading: loading, pagination }}
        enableBottomToolbar
        enableColumnActions
        enableRowActions={false}
        enableDensityToggle={false}
        enablePagination
        renderTopToolbar={false}
      />
    </div>
  );
}
